<template>
  <div class="page-content content" v-if="model.homeTeam">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-md-6">
        <ntm-block :title="$tc('livestream.name', 1)">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span>{{ $t('formly.fields.livestreamEvent') }}</span>
            <div class="d-flex align-items-center">
              <div v-if="model.hasYoutubeConnectedAccount && model.embedVideoSourceType !== 'YOUTUBE'" class="yt-create-badge btn-dual mr-1" :class="{ 'yt-create-badge--disabled': ytLoading }" @click="!ytLoading && createYtEvent()">
                <span class="mr-1" style="position: relative; display: inline-flex; font-size: 18px; line-height: 1;">
                  <i class="fa fa-youtube-play" style="color: #dc3545;"></i>
                  <i class="fa fa-play" style="position: absolute; top: 50%; left: 53%; transform: translate(-50%, -50%); font-size: 0.42em; color: #fff;"></i>
                </span>
                <span>{{ $t('createEvent') }}</span>
                <span class="yt-create-badge__icon ml-2" style="font-size: 14px;">
                  <i v-if="ytLoading" class="fa fa-cog fa-spin"></i>
                  <i v-else class="fa fa-plus yt-create-badge__icon--green"></i>
                </span>
              </div>
              <div v-if="model.hasYoutubeConnectedAccount && model.embedVideoSourceType === 'YOUTUBE'" class="yt-active-badge bg-success mr-1">
                <span class="yt-active-badge__label">
                  <span class="mr-1" style="position: relative; display: inline-flex; font-size: 18px; line-height: 1;">
                    <i class="fa fa-youtube-play" style="color: #dc3545;"></i>
                    <i class="fa fa-play" style="position: absolute; top: 50%; left: 53%; transform: translate(-50%, -50%); font-size: 0.42em; color: #fff;"></i>
                  </span>
                  <span>{{ $t('eventCreated') }}</span>
                </span>
                <button :disabled="ytLoading" class="yt-active-badge__delete btn-danger" @click="deleteYtEvent()">
                  <i v-if="ytLoading" class="fa fa-cog fa-spin"></i>
                  <i v-else class="fa fa-trash-o"></i>
                </button>
              </div>
              <button v-if="model.embedVideoSourceType !== 'YOUTUBE'" class="btn btn-sm btn-primary" @click="$refs.embedVideo.open()">
                <i class="fa fa-video-camera"></i>
              </button>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span>{{ $t('formly.fields.gameWidgetLink') }}</span>
            <div>
              <le-copy-to-clipboard icon="fa fa-copy" :text="getGameBroadcastWebsiteUrl(model)"></le-copy-to-clipboard>
              <le-q-rcode :link="getGameBroadcastWebsiteUrl(model)" :name="model.slug" class="ml-1" />
              <button v-if="canShare" class="btn btn-sm btn-circle btn-info flex-shrink-0 ml-1" v-tooltip="$t('tooltip.share')" @click="shareLink(getGameBroadcastWebsiteUrl(model))">
                <i class="fa fa-share-alt"></i>
              </button>
            </div>
          </div>
          <div v-if="venue" class="d-flex align-items-center justify-content-between pb-3">
            <span>{{ $t('formly.fields.venueWidgetLink') }}</span>
            <div class="d-flex align-items-center">
              <button class="btn btn-sm btn-circle btn-info mr-1" v-tooltip="$t('tooltip.copyLink')" @click="copyToClipboard(venueBroadcastLink(venue))">
                <i class="fa fa-copy"></i>
              </button>
              <le-q-rcode :link="venueBroadcastLink(venue)" :name="venue.name" class="mr-1" />
              <button v-if="canShare" class="btn btn-sm btn-circle btn-info flex-shrink-0" v-tooltip="$t('tooltip.share')" @click="shareLink(venueBroadcastLink(venue))">
                <i class="fa fa-share-alt"></i>
              </button>
            </div>
          </div>
        </ntm-block>
      </div>
    </div>
    <h1 class="text-center display-3">PRE GAME</h1>
    <div class="row">
      <div class="col-xl-5 col-md-6 offset-xl-1">
        <button v-if="config.pre_game.add_players" class="btn btn-sm btn-success w-100" @click="playerCreateModal(model.homeTeam.uuid)">{{$t('player.add')}}</button>
        <ntm-block v-if="model.homeTeam" :title="model.homeTeam.name">
          <div class="team-color d-flex justify-content-between align-items-center">
            <span>{{$tc('team.color', 1)}}:</span>
            <v-swatches
              v-model="homeTeamColor"
              :swatches="colorOptions"
              popover-x="left"
            ></v-swatches>
          </div>
          <table v-if="model.homeTeam && model.homeTeam.players.length > 0" class="table player-live-table table-hover table-vcenter font-size-sm">
            <thead>
            <tr>
              <th class="number-of-jersey-suggestion"></th>
              <th class="text-center">{{$t('pre_game.table.jersey')}}</th>
              <th>{{$t('pre_game.table.name')}}</th>
              <th v-if="lineupPositions.length" class="text-center" style="width: 60px;">Pos</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(player, n) in model.homeTeam.players" :key="player.uuid">
              <td class="d-sm-table-cell">
                <button @click="updateNumberOfJersey('homeTeam', n, player.number_of_jersey_suggestion)" v-if="!player.number_of_jersey && player.number_of_jersey_suggestion" class="btn btn-sm btn-info">
                  {{player.number_of_jersey_suggestion}}
                </button>
                <button @click="removeNumberOfJersey('homeTeam', n)" v-if="player.number_of_jersey" class="btn btn-sm btn-warning">
                  <i class="fa fa-times"></i>
                </button>
              </td>
              <td class="d-sm-table-cell font-w600 text-center number-of-jersey-column" style="font-size: 18px">
                <input class="form-control number-of-jersey-input" v-model="model.homeTeam.players[n].number_of_jersey"  type="number" :data-testid="'pregame-jersey-' + player.uuid"></td>
              <td class="d-sm-table-cell font-w600 pl-2">
                <!-- the name with the birth year always below it, centered in the row -->
                <div class="d-flex flex-column justify-content-center">
                  <div>
                    {{player.name}}
                    <span v-for="tag in player.player_tags" :key="tag.uuid" class="badge ml-1" :style="playerTagStyle(tag)">{{ tag.name }}</span>
                  </div>
                  <small v-if="player.birthYear" class="text-muted font-w400">{{ player.birthYear }}</small>
                </div>
              </td>
              <td v-if="lineupPositions.length" class="text-center">
                <button @click="openPositionModal('homeTeam', n)" class="btn btn-sm" :style="player.position ? positionButtonStyle(player.position) : ''" :class="player.position ? '' : 'btn-outline-secondary'">
                  {{ player.position || '—' }}
                </button>
              </td>
              <td class="d-sm-table-cell column-img font-w600 d-flex justify-content-between align-items-center">
                <div class="d-inline-block" @click="updatePlayerImage(player)">
                  <img v-if="player.profile" :src="player.profile" alt="" class="img-avatar img-avatar32"><img v-else src="/empty-player.jpg" alt="" class="img-avatar img-avatar32">
                </div>
                <button v-if="config.pre_game.add_players && isAdminOrInternalScorekeeper" class="btn btn-sm btn-secondary ml-2" @click.stop="playerEditModal(model.homeTeam.uuid, player)">
                  <i class="fa fa-pencil"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="homeErrors.length > 0" class="text-danger">
            <p><strong>{{$tc('errors.name', 2)}}:</strong></p>
            <ul>
              <li v-for="error in homeErrors" :key="error">{{showError(error)}}</li>
            </ul>
          </div>
        </ntm-block>
        <label v-if="config.pre_game.add_players" class="mb-1 font-w600" for="homeTeamPlayerSearch">{{ $t('player.addExisting') }}</label>
        <v-select v-if="config.pre_game.add_players" class="mb-4" @search="searchPlayer" :filter="(options) => options" @option:selected="(e) => selectPlayer(e, model.homeTeam.uuid)"
                  v-model="addSelectedPlayer" :options="playerFilteredOptions" inputId="homeTeamPlayerSearch" label="name"
                  :placeholder="$tc('player.searchAndAdd')">
          <template #option="option">
            {{ option.name }}<small v-if="option.birthYear" class="ml-1" style="opacity: .7">({{ option.birthYear }})</small>
          </template>
          <template #no-options>
            <p class="info">{{ $tc('player.searchAndAdd') }}</p>
          </template>
        </v-select>
      </div>
      <div class="col-xl-5 col-md-6">
        <button v-if="config.pre_game.add_players" class="btn btn-sm btn-success w-100" @click="playerCreateModal(model.awayTeam.uuid)">{{$t('player.add')}}</button>
        <ntm-block v-if="model.awayTeam" :title="model.awayTeam.name">
          <div class="team-color d-flex justify-content-between align-items-center">
            <span>{{$tc('team.color', 1)}}:</span>
            <v-swatches
              v-model="awayTeamColor"
              popover-x="left"
              :swatches="colorOptions"
            ></v-swatches>
          </div>
          <table v-if="model.awayTeam && model.awayTeam.players.length > 0" class="table player-live-table table-hover table-vcenter font-size-sm">
            <thead>
            <tr>
              <th class="number-of-jersey-suggestion"></th>
              <th class="text-center">{{$t('pre_game.table.jersey')}}</th>
              <th>{{$t('pre_game.table.name')}}</th>
              <th v-if="lineupPositions.length" class="text-center" style="width: 60px;">Pos</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(player, n) in model.awayTeam.players" :key="player.uuid">
              <td class="d-sm-table-cell">
                <button @click="updateNumberOfJersey('awayTeam', n, player.number_of_jersey_suggestion)" v-if="!player.number_of_jersey && player.number_of_jersey_suggestion" class="btn btn-sm btn-info">
                  {{player.number_of_jersey_suggestion}}
                </button>
                <button @click="removeNumberOfJersey('awayTeam', n)" v-if="player.number_of_jersey" class="btn btn-sm btn-warning">
                  <i class="fa fa-times"></i>
                </button>
              </td>
              <td class="d-sm-table-cell font-w600 text-center number-of-jersey-column" style="font-size: 18px">
                <input class="form-control number-of-jersey-input" v-model="model.awayTeam.players[n].number_of_jersey" type="number" :data-testid="'pregame-jersey-' + player.uuid"></td>
              <td class="d-sm-table-cell font-w600 pl-2">
                <!-- the name with the birth year always below it, centered in the row -->
                <div class="d-flex flex-column justify-content-center">
                  <div>
                    {{player.name}}
                    <span v-for="tag in player.player_tags" :key="tag.uuid" class="badge ml-1" :style="playerTagStyle(tag)">{{ tag.name }}</span>
                  </div>
                  <small v-if="player.birthYear" class="text-muted font-w400">{{ player.birthYear }}</small>
                </div>
              </td>
              <td v-if="lineupPositions.length" class="text-center">
                <button @click="openPositionModal('awayTeam', n)" class="btn btn-sm" :style="player.position ? positionButtonStyle(player.position) : ''" :class="player.position ? '' : 'btn-outline-secondary'">
                  {{ player.position || '—' }}
                </button>
              </td>
              <td class="d-sm-table-cell column-img font-w600 d-flex justify-content-between align-items-center">
                <div class="d-inline-block" @click="updatePlayerImage(player)">
                  <img v-if="player.profile" :src="player.profile" alt="" class="img-avatar img-avatar32"><img v-else src="/empty-player.jpg" alt="" class="img-avatar img-avatar32">
                </div>
                <button v-if="config.pre_game.add_players && isAdminOrInternalScorekeeper" class="btn btn-sm btn-secondary ml-2" @click.stop="playerEditModal(model.awayTeam.uuid, player)">
                  <i class="fa fa-pencil"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="awayErrors.length > 0" class="text-danger">
            <p><strong>{{$tc('errors.name', 2)}}:</strong></p>
            <ul>
              <li v-for="error in awayErrors" :key="error">{{showError(error)}}</li>
            </ul>
          </div>
        </ntm-block>
        <label v-if="config.pre_game.add_players" class="mb-1 font-w600" for="awayTeamPlayerSearch">{{ $t('player.addExisting') }}</label>
        <v-select v-if="config.pre_game.add_players" class="mb-4" @search="searchPlayer" :filter="(options) => options" @option:selected="(e) => selectPlayer(e, model.awayTeam.uuid)"
                  v-model="addSelectedPlayer" :options="playerFilteredOptions" inputId="awayTeamPlayerSearch" label="name"
                  :placeholder="$tc('player.searchAndAdd')">
          <template #option="option">
            {{ option.name }}<small v-if="option.birthYear" class="ml-1" style="opacity: .7">({{ option.birthYear }})</small>
          </template>
          <template #no-options>
            <p class="info">{{ $tc('player.searchAndAdd') }}</p>
          </template>
        </v-select>
      </div>
    </div>
    <div class="row text-center mt-3 mb-5">
      <div class="col-sm-12 text-center">
        <button class="btn btn-success btn-lg" data-testid="pregame-go-live" :disabled="goLiveIsLoading" @click="goLive()">
          <i v-if="goLiveIsLoading" class="fa fa-cog fa-spin"></i>
          <span v-if="!goLiveIsLoading">Go live</span>
        </button>
      </div>
    </div>
    <modal name="pregame-position" height="auto" :minWidth="280" width="320">
      <div class="p-4" v-if="positionModal.player !== null">
        <h6 class="mb-3">{{ positionModal.player.name }}</h6>
        <div class="d-flex flex-wrap mb-3" style="gap: 8px;">
          <button
            v-for="pos in lineupPositions"
            :key="pos.id"
            @click="setPreGamePosition(pos.id)"
            class="btn btn-sm font-w700"
            :style="positionModal.player.position === pos.id ? `background:${pos.color};color:#fff;border-color:${pos.color}` : `border-color:${pos.color};color:${pos.color}`"
          >
            {{ pos.name }}
          </button>
        </div>
        <button @click="setPreGamePosition(null)" class="btn btn-sm btn-outline-danger">
          Clear
        </button>
      </div>
    </modal>

    <ntm-modal @closed="selectedPlayer = null" size="lg" ref="updatePlayerImageModal">
      <ntm-crop :key="selectedPlayer.uuid" v-if="selectedPlayer" @change="updatePlayerProfile"  entity-type="player" :entity-uuid="selectedPlayer.uuid" collection="profile" :circle="true"></ntm-crop>
    </ntm-modal>

    <ntm-modal size="lg" ref="embedVideo">
      <form id="embedVideo" @submit.prevent="onEmbedVideoSubmit()">
        <formly-form :form="embedVideoForm" :model="embedVideoModel" :fields="embedVideoFields"></formly-form>
        <button class="btn btn-success push-15">{{ $t('save') }}</button>
      </form>

    </ntm-modal>

    <ntm-sidebar @close="teamUuid = null" :title="editingPlayerUuid ? $t('player.edit') : $t('player.create')" name="add-player">
      <form id="playerForm" @submit.prevent="onPlayerSubmit()">
        <formly-form :form="playerForm" :model="playerModel" :fields="playerFields"></formly-form>
        <button class="btn btn-success push-15">{{ $t('save') }}</button>
      </form>
    </ntm-sidebar>
  </div>
</template>

<script>
import GameService from '@/services/game.service'
import router from '@/router'
import store from '@/store'
import playerFields from '@/formDefinitions/player'
import embedVideoFields from '@/formDefinitions/embedVideo'
import { useRouteQuery } from '@/use/useRouteQuery'
import _ from 'lodash'
import TeamService from '../services/team.service'
import GlobalService from '../services/global.service'
import { useExternalLinks } from '@/use/useExternalLinks'
import VSwatches from 'vue-swatches'
import { ToastMessage } from '@/lib/toast'
import { shareUrl } from '@/lib/share'
import LeQRcode from '@/components/le/LeQRcode.vue'
export default {
  name: 'preGame',
  components: { VSwatches, LeQRcode },
  setup () {
    const { getGameBroadcastWebsiteUrl } = useExternalLinks()
    const addPlayer = useRouteQuery('add-player')
    const teamUuid = useRouteQuery('team')
    return {
      addPlayer,
      teamUuid,
      getGameBroadcastWebsiteUrl
    }
  },
  data () {
    return {
      colorOptions: [
        '#2ECC70',
        '#27AF60',
        '#3398DB',
        '#2980B9',
        '#AE80C2',
        '#A463BF',
        '#FDD01C',
        '#ECA713',
        '#BA8A21',
        '#E38A82',
        '#EF5A4D',
        '#CCCCCC'
      ],
      homeTeamColor: localStorage.getItem('homeTeamColor') ?? '#70b9eb',
      awayTeamColor: localStorage.getItem('awayTeamColor') ?? '#70b9eb',
      debtEntityType: null,
      debtEntity: null,
      goLiveIsLoading: false,
      ytLoading: false,
      debts: [],
      model: {},
      venue: null,
      homeErrors: [],
      awayErrors: [],
      playerOptions: [],
      selectedPlayer: null,
      addSelectedPlayer: null,
      playerFormTeamUuid: null,
      editingPlayerUuid: null,
      playerForm: {},
      playerModel: {
        firstName: '',
        lastName: '',
        middleName: '',
        birthYear: ''
      },
      playerFields: playerFields,
      embedVideoForm: {},
      embedVideoModel: {
        code: ''
      },
      embedVideoFields: embedVideoFields,
      positionModal: {
        teamKey: null,
        playerIndex: null,
        player: null
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!store.getters.isAdminOrInternalScorekeeper && !store.getters.isExternalScorekeeper) {
      return next('/')
    }
    GameService.status().then((response) => {
      if (response.data === 'FINISHED') {
        router.push({ name: 'archive', params: { clientId: to.params.clientId, code: to.params.code } })
      } else if (response.data === 'LIVE') {
        // A live game gets the roster edit view instead of the pre game view
        next({ name: 'liveRoster', params: { clientId: to.params.clientId, code: to.params.code } })
      } else {
        Promise.all([GameService.preGame(), GameService.index()]).then(([preGameResponse, gamesResponse]) => {
          const game = gamesResponse.data.games.find((game) => game.code === to.params.code)
          next(vm => vm.setData(preGameResponse.data, game?.venue ?? null))
        })
      }
    })
  },
  methods: {
    shareLink (url) {
      return shareUrl(url)
    },
    venueBroadcastLink (venue) {
      const { getWebsiteDomain } = useExternalLinks()
      return `${getWebsiteDomain()}/venues/${venue.uuid}/broadcast-game`
    },
    copyToClipboard (text) {
      navigator.clipboard.writeText(text)
    },
    searchPlayer (search, loading) {
      if (search.length > 0) {
        loading(true)
        this.searchGlobalPlayers(search, loading)
      } else {
        this.playerOptions = []
      }
    },
    focusAddNewPlayerFirstField () {
      setTimeout(() => {
        const playerFormFirstName = document.querySelector('#playerForm .form-control')
        playerFormFirstName.focus()
      })
    },
    selectPlayer (player, team) {
      this.addSelectedPlayer = null
      if (player.uuid === 'add') {
        this.playerCreateModal(team)
        return
      }
      TeamService.addPlayerToTeam(team, { playerUuid: player.uuid }).then((res) => {
        this.pushPlayerToTeam(res.data, team)
      }).catch((err) => {
        const anotherTeam = (err.response?.data?.errors?.playerUuid?.[0] ?? '').split('|')[1]
        ToastMessage({
          title: anotherTeam ? `${this.$t('player.in_another_team')} (${anotherTeam})` : this.$t('player.in_another_team'),
          icon: 'error'
        })
      }).finally(() => {
        this.addSelectedPlayer = null
      })
    },
    searchGlobalPlayers: _.debounce(function (search, loading) {
      GlobalService.searchPlayers(search).then((res) => {
        this.playerOptions = res.data
        if (!this.playerFilteredOptions.length) {
          this.playerOptions.push({ name: this.$t('player.add'), uuid: 'add' })
        }
        loading(false)
      })
    }, 300),
    playerCreateModal (teamUuid) {
      if (!this.config.pre_game.add_players) return
      this.addPlayer = true
      this.teamUuid = teamUuid
      // reset edit state and clear form
      this.editingPlayerUuid = null
      this.playerModel = {
        firstName: '',
        lastName: '',
        middleName: '',
        birthYear: ''
      }
      this.focusAddNewPlayerFirstField()
    },
    playerEditModal (teamUuid, player) {
      if (!this.config.pre_game.add_players) return
      this.addPlayer = true
      this.teamUuid = teamUuid
      this.editingPlayerUuid = player.uuid
      this.playerModel = {
        firstName: player.firstName || '',
        lastName: player.lastName || '',
        middleName: player.middleName || '',
        birthYear: player.birthYear || ''
      }
      this.focusAddNewPlayerFirstField()
    },
    updateLocalPlayer (updated) {
      const update = (team) => {
        const idx = team.players.findIndex(p => p.uuid === updated.uuid)
        if (idx !== -1) {
          team.players.splice(idx, 1, updated)
        }
      }
      if (this.model.homeTeam) update(this.model.homeTeam)
      if (this.model.awayTeam) update(this.model.awayTeam)
    },
    pushPlayerToTeam (player, teamUuid) {
      if (this.model.homeTeam.uuid === teamUuid) {
        this.model.homeTeam.players.push(player)
      }
      if (this.model.awayTeam.uuid === teamUuid) {
        this.model.awayTeam.players.push(player)
      }
    },
    onPlayerSubmit () {
      this.playerForm.$errors = {}
      const resetAndClose = () => {
        this.addPlayer = null
        this.teamUuid = null
        this.editingPlayerUuid = null
        this.playerModel = {
          firstName: '',
          lastName: '',
          middleName: '',
          birthYear: ''
        }
      }

      if (this.editingPlayerUuid) {
        TeamService.editPlayer(this.teamUuid, this.editingPlayerUuid, this.playerModel).then((res) => {
          this.updateLocalPlayer(res.data)
          resetAndClose()
        }).catch((err) => {
          this.playerForm.$errors = err.response?.data?.errors || {}
        })
        return
      }

      TeamService.createAndAddNewPlayerToTeam(this.teamUuid, this.playerModel).then((res) => {
        this.pushPlayerToTeam(res.data, this.teamUuid)
        resetAndClose()
      }).catch((err) => {
        this.playerForm.$errors = err.response?.data?.errors || {}
      })
    },
    onEmbedVideoSubmit () {
      GameService.embedVideo(this.embedVideoModel).then(() => {
        this.model.embedVideoCode = this.embedVideoModel.code
        this.model.embedVideoSourceType = null
        this.$refs.embedVideo.close()
      })
    },
    createYtEvent () {
      this.ytLoading = true
      GameService.createYtEvent().then(() => {
        this.model.embedVideoSourceType = 'YOUTUBE'
      }).finally(() => {
        this.ytLoading = false
      })
    },
    deleteYtEvent () {
      this.ytLoading = true
      GameService.deleteYtEvent().then(() => {
        this.model.embedVideoSourceType = null
        this.model.embedVideoCode = null
        this.embedVideoModel.code = ''
      }).finally(() => {
        this.ytLoading = false
      })
    },
    updatePlayerImage (player) {
      this.addPlayer = false
      this.selectedPlayer = player
      this.$refs.updatePlayerImageModal.open()
    },
    updatePlayerProfile (imageUrl) {
      if (!this.config.pre_game.upload_images) return
      const homePlayer = this.model.homeTeam.players.find((player) => player.uuid === this.selectedPlayer.uuid)
      if (homePlayer) {
        homePlayer.profile = imageUrl
      }

      const awayPlayer = this.model.awayTeam.players.find((player) => player.uuid === this.selectedPlayer.uuid)
      if (awayPlayer) {
        awayPlayer.profile = imageUrl
      }

      this.$refs.updatePlayerImageModal.close()
    },
    async goLive () {
      this.goLiveIsLoading = true
      GameService.goLive(this.model).then(() => {
        this.homeErrors = []
        this.awayErrors = []
        if (this.model.status === 'SCHEDULED' && this.model.embedVideoCode) {
          this.$swal.fire({
            title: `<strong>${this.$t('livestream.swal.check.title')}</strong>`,
            icon: 'info',
            html: this.model.embedVideoCode,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: `
            <i class="fa fa-thumbs-up"></i> ${this.$t('livestream.swal.check.confirm')}
          `,
            confirmButtonAriaLabel: 'Livestream is ready!'
          }).then((result) => {
            if (result.value) {
              router.push({ name: 'live' })
            }
          }).finally(() => {
            this.goLiveIsLoading = false
          })
        } else {
          router.push({ name: 'live' })
        }
      }).catch((err) => {
        this.homeErrors = []
        this.awayErrors = []
        const errors = err.response?.data?.errors || {}

        Object.keys(errors).forEach((key) => {
          if (key.includes('homeTeam')) {
            errors[key].forEach((error) => {
              this.homeErrors.push(error)
            })
          } else if (key.includes('awayTeam')) {
            errors[key].forEach((error) => {
              this.awayErrors.push(error)
            })
          }
        })

        this.goLiveIsLoading = false
      })
    },
    showError (error) {
      const arrErrorTypes = error.split('.')
      const errorType = arrErrorTypes[arrErrorTypes.length - 1]
      const errorTypeArray = errorType.split('|')
      const errorTypeName = errorTypeArray.shift()

      return this.$t('errors.live.preGame.' + errorTypeName, errorTypeArray)
    },
    setData (data, venue) {
      this.model = data
      this.embedVideoModel.code = data.embedVideoCode
      this.venue = venue
    },
    updateNumberOfJersey (team, playerIndex, numberOfJersey) {
      this.model[team].players[playerIndex].number_of_jersey = numberOfJersey
    },
    removeNumberOfJersey (team, playerIndex) {
      this.model[team].players[playerIndex].number_of_jersey = null
    },
    openPositionModal (teamKey, playerIndex) {
      this.positionModal = {
        teamKey,
        playerIndex,
        player: this.model[teamKey].players[playerIndex]
      }
      this.$modal.show('pregame-position')
    },
    setPreGamePosition (positionId) {
      const { teamKey, playerIndex } = this.positionModal
      this.$set(this.model[teamKey].players[playerIndex], 'position', positionId)
      this.positionModal.player = this.model[teamKey].players[playerIndex]
      this.$modal.hide('pregame-position')
    },
    positionButtonStyle (positionId) {
      const pos = this.lineupPositions.find(p => p.id === positionId)
      if (!pos) return ''
      return `background:${pos.color};color:#fff;border-color:${pos.color}`
    },
    playerTagStyle (tag) {
      if (!tag || !tag.color) return {}
      return { backgroundColor: tag.color, color: '#fff' }
    }
  },
  watch: {
    awayTeamColor (val) {
      localStorage.setItem('awayTeamColor', val)
    },
    homeTeamColor (val) {
      localStorage.setItem('homeTeamColor', val)
    }
  },
  computed: {
    canShare () {
      return !!navigator.share
    },
    isAdminOrInternalScorekeeper () {
      return this.$store.getters.isAdminOrInternalScorekeeper
    },
    homePlayersUuids () {
      return this.model.homeTeam.players.map(player => player.uuid)
    },
    awayPlayersUuids () {
      return this.model.awayTeam.players.map(player => player.uuid)
    },
    playerFilteredOptions () {
      return this.playerOptions.filter((player) => {
        const mergePlayers = this.homePlayersUuids.concat(this.awayPlayersUuids)
        return !mergePlayers.includes(player.uuid)
      })
    },
    config () {
      return this.$store.state.config
    },
    lineupPositions () {
      return (this.config?.live?.positions ?? []).filter(a => a.count > 0)
    }
  }
}

</script>

<style lang="scss">
.btn-success {
  background-color: #00B5ACFF !important;
}

.number-of-jersey-suggestion {
  width: 40px;
}

.punishment-cell {
  width: 40px;
}

.number-of-jersey-column {
  width: 65px;
}

.form-control.number-of-jersey-input {
  text-align: center;
  width: 65px;
  margin: auto;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}

.debt-button i {
  font-size: 16px;
}

.team-color {
  padding: 5px 0;
  .vue-swatches .vue-swatches__trigger__wrapper {
    display: block;
  }
  span {
    font-weight: bold;
  }
}

.yt-create-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  line-height: 1.5;
  cursor: pointer;

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    font-size: 0.7em;

    &--green {
      color: #28a745;
    }
  }
}

.yt-active-badge {
  display: inline-flex;
  align-items: stretch;
  background-color: #dc3545;
  color: #fff;
  border-radius: 4px;
  padding: 0;
  font-size: 0.8rem;
  line-height: 1.5;
  overflow: hidden;

  &__label {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
  }

  &__delete {
    display: inline-flex;
    align-items: center;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.8);
    margin-left: 0;
    cursor: pointer;
    line-height: 1;

    &:hover:not(:disabled) {
      color: #fff;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
